import React from "react";
import { StarIcon } from "lucide-react";
import { product } from "../../data/product";
export function Rating() {
  return <p className="flex items-center justify-center gap-2 text-[15px] text-ink" data-id="element-189" data-mp="3fq6q5v601to4">
      <span className="flex gap-0.5" aria-hidden="true" data-id="element-190" data-mp="3ug4ag00t5z81">
        {Array.from({
        length: 5
      }).map((_, i) => <StarIcon key={i} className="h-[18px] w-[18px] fill-[#D4A64A] text-[#D4A64A]" data-id="element-191" data-mp="3pi2o96835jsc" data-mpi={i} />)}
      </span>
      <span data-id="element-192" data-mp="31rp4s43kgt9d">
        {product.rating} ({product.reviewsCount})
      </span>
    </p>;
}